import { useState } from 'react';
import { HeronMark } from '../components/icons';
import { Button, ErrorNote, TextField } from '../components/ui';
import { useAuth } from '../lib/auth';

export function LoginPage() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signIn(email, password);
    } catch (caught) {
      setError(caught);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="gate">
      <form className="gate__card" onSubmit={submit}>
        <div className="gate__brand">
          <HeronMark size={24} />
          <span>Heron License</span>
        </div>

        <h1 className="gate__title">Sign in</h1>
        <p className="gate__sub">
          Internal licensing console. Staff accounts only — customers never sign in here.
        </p>

        <div className="gate__fields">
          {error ? <ErrorNote error={error} /> : null}

          <TextField
            label="Email"
            type="email"
            value={email}
            required
            autoComplete="username"
            autoFocus
            onChange={(event) => setEmail(event.currentTarget.value)}
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            required
            autoComplete="current-password"
            onChange={(event) => setPassword(event.currentTarget.value)}
          />

          <Button type="submit" variant="primary" size="lg" block loading={busy}>
            Sign in
          </Button>
        </div>

        <p className="gate__foot">
          Locked out? Another superadmin can reset your password directly in the database. There is
          deliberately no self-service reset for staff accounts.
        </p>
      </form>
    </div>
  );
}
